import { ITutorialPassos, MensagensPadrao } from "../../Ajuda";

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-do-perfil",

    filtroDeNome: "campo-nome-filtros-do-perfil",
    filtroDeAtivo: "campo-ativo-filtros-do-perfil",

    botaoListar: "botao-listar-perfis",
    botaoVincular: "botao-vincular-perfis-perfil",
    botaoAdicionar: "botao-adicionar-perfil",
}

export const Classes = {
    botaoEditar: "botao-editar-perfil",
    botaoDesativar: "botao-desativar-perfil",
}

export const ConsultarPerfil: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)! },
        { ...MensagensPadrao.filtros.nome, target: () => document.getElementById(IDs.filtroDeNome)! },
        { ...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)! },
        { ...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const AdicionarPerfil: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)! },
    ]
}

export const VincularPerfil: ITutorialPassos = {
    steps: [
        {
            title: `Clique em "Vincular usuários"`,
            description: "Obtenha mais informações sobre como vincular um perfil à um usuário clicando no ícone '?' a partir do painel seguinte.",
            target: () => document.getElementById(IDs.botaoVincular)!
        }
    ]
}

export const EditarPerfil: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector('.' + Classes.botaoEditar)! },
    ]
}

export const DesativarPerfil: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.desativar, target: () => document.querySelector('.' + Classes.botaoDesativar)! },
    ]
}
